import apis from "../../../api";
import {
  eventGetMyDraftsAction,
  eventGetPublishedByMeAction,
  eventGetPublishedByOthersAction,
  eventGetClassByTags,
  eventGetClassByTagsVirtualTraining,
} from "../actionCreators/eventActionCreator";
import { errorTypes } from "../../../utils/errorTypes";
import { setErrorHandler } from "./errorActionHandler";

const { SUCCESS, WARN, FAIL } = errorTypes;
export const eventGetMyDraftsActionHandler =
  (
    searchText = "",
    pageNumber,
    pageSize,
    setMyDraftsData,
    setTempMyDraftsData,
    setTotalRows,
    onlyCount = false
  ) =>
    async (dispatch) => {
      await apis.events
        .eventGetMyDrafts(searchText, pageNumber, pageSize)
        .then((response) => {
          if (response) {
            dispatch(eventGetMyDraftsAction(null, response.data.TotalRows));
            if (!onlyCount) {
              setMyDraftsData((prevStateData) => [
                ...prevStateData,
                ...response.data.Content,
              ]);
              setTempMyDraftsData((prevStateData) => [
                ...prevStateData,
                ...response.data.Content,
              ]);
              setTotalRows(response.data.TotalRows);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };
export const eventGetPublishedByMeActionHandler =
  (
    searchText = "",
    pageNumber,
    pageSize,
    setPublishedByMeData,
    setTempPublishedByMeData,
    setTotalRows,
    onlyCount = false
  ) =>
    async (dispatch) => {
      
      await apis.events
        .eventGetPublishedByMe(searchText, pageNumber, pageSize)
        .then((response) => {
          const uniqueData = response?.data?.Content.map((item) => ({
            ...item,
            uniqueFieldName: `${item.ID}-${Math.random()}`,
          }));
          dispatch(eventGetPublishedByMeAction(null, response.data.TotalRows));
          if (!onlyCount) {
            setPublishedByMeData((prevStateData) => [
              ...prevStateData,
              ...uniqueData,
            ]);
            setTempPublishedByMeData((prevStateData) => [
              ...prevStateData,
              ...uniqueData,
            ]);
            setTotalRows(response.data.TotalRows);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

export const eventGetPublishedByOthersActionHandler =
  (
    searchText = "",
    pageNumber,
    pageSize,
    setPublishedByOthersData,
    setTempPublishedByOthersData,
    setTotalRows,
    onlyCount = false
  ) =>
    async (dispatch) => {
      await apis.events
        .eventGetPublishedByOthers(searchText, pageNumber, pageSize)
        .then((response) => {
          const uniqueData = response?.data?.Content.map((item) => ({
            ...item,
            uniqueFieldName: `${item.ID}-${Math.random()}`,
          }));
          dispatch(
            eventGetPublishedByOthersAction(null, response.data.TotalRows)
          );
          if (!onlyCount) {
            setPublishedByOthersData((prevStateData) => [
              ...prevStateData,
              ...uniqueData,
            ]);
            setTempPublishedByOthersData((prevStateData) => [
              ...prevStateData,
              ...uniqueData,
            ]);
            setTotalRows(response.data.TotalRows);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

export const deleteEventShotclassActionHandler =
  (
    shotclassId
    // setData,
    // setUpdatedData,
    // handleSearchQuery
  ) =>
    async (dispatch) => {
      return await apis.events
        .deleteEventShotClass(shotclassId)
        .then((response) => {
          return response.data;
          // if (response.data === true) {
          //   // handleSearchQuery();
          //   dispatch(setErrorHandler(SUCCESS, "Event has been deleted"));
          // }
        });
    };

export const createEventShotclassActionHandler =
  (shotclassData, Status) => async (dispatch) => {
    let quizQuestionList = shotclassData.addQuiz.QuestionsList.map(
      (question, index) => {
        return {
          Type: question.ActiveQuestionType,
          Text: question.Question,
          PositiveMark: 1,
          NegativeMark: 0,
          QuestionNo: index + 1,
          ChoiceList:
            question.ActiveQuestionType === 1
              ? question.AnswersList.map((answer, index) => {
                return {
                  Text: answer?.Answer,
                  IsAnswer: parseInt(question.IsCorrect) === index,
                  ChoiceImageList: answer?.AnswerImage?.MediaUri
                    ? {
                      MediaUri: answer?.AnswerImage?.MediaUri,
                      FileName: answer?.AnswerImage?.FileName,
                      Mediaid: answer?.AnswerImage?.Mediaid,
                      FileType: answer?.AnswerImage?.FileType,
                      FileSizeinKB: answer?.AnswerImage?.FileSizeinKB,
                      Base64: "",
                      ThumbnailUri: answer?.AnswerImage?.ThumbnailUri,
                      LabelValue: "",
                    }
                    : null,
                  ChoiceAudioList: null,
                  ChoiceVideoList: null,
                };
              })
              : [
                {
                  Text: "True",
                  IsAnswer: question.IsCorrect === "True",
                  keyText: "TRUE_TEXT",
                },
                {
                  Text: "False",
                  IsAnswer: question.IsCorrect === "False",
                  keyText: "FALSE_TEXT",
                },
              ],
          Explaination: question.Explanation,
          AnswerHint: "",
          QuestionImageList:
            question?.QuestionImage?.[0]?.checked == true
              ? question?.QuestionImage?.map((item) => {
                return {
                  MediaUri: item?.MediaUri,
                  FileName: item?.FileName,
                  Mediaid: item?.Mediaid,
                  FileType: item?.FileType,
                  FileSizeinKB: item?.FileSizeinKB,
                  Base64: "",
                  ThumbnailUri: item?.ThumbnailUri,
                  LabelValue: "",
                  isSelected: true,
                };
              })
              : [],
          // QuestionImageList: question?.QuestionImage?.map((item) => {
          //   return {
          //     MediaUri: item?.MediaUri,
          //     FileName: item?.FileName,
          //     Mediaid: item?.Mediaid,
          //     FileType: item?.FileType,
          //     FileSizeinKB: item?.FileSizeinKB,
          //     Base64: "",
          //     ThumbnailUri: item?.ThumbnailUri,
          //     LabelValue: "",
          //     isSelected: true,
          //   };
          // }),

          // QuestionImageList: question?.QuestionImage?.MediaUri
          //   ? [
          //       {
          //         MediaUri: question?.QuestionImage?.MediaUri,
          //         FileName: question?.QuestionImage?.FileName,
          //         Mediaid: question?.QuestionImage?.Mediaid,
          //         FileType: question?.QuestionImage?.FileType,
          //         FileSizeinKB: question?.QuestionImage?.FileSizeinKB,
          //         Base64: "",
          //         ThumbnailUri: question?.QuestionImage?.ThumbnailUri,
          //         LabelValue: "",
          //         isSelected: true,
          //       },
          //     ]
          //   : [],
          QuestionVideoList: [],
          Duration: question.Duration,
          ImageIcon: true,
        };
      }
    );
    let data = {
      ID: 0,
      Name: shotclassData.details.Name,
      AssessmentSet: {
        AllowReattempt: false,
        Description: "",
        Duration: 1,
        ID: 0,
        Locale: shotclassData.details.Language,
        MaxScore: 100,
        MinScore: "",
        Name: shotclassData.details.Name,
        ParentId: 0,
        QuestionList:
        shotclassData.addQuiz.TotalQuestionCount > 0 ? quizQuestionList : [],
      },
      EnableTimer: shotclassData.addQuiz.EnableTimer || false,
      QuizDuration: shotclassData.addQuiz.QuizDuration || 0,
      CategoryID: "",
      Credits: "",
      // ImageUrl: shotclassData.details.ThumbnailImage.MediaUri,
      ImageUrl:
        "https://dev1shotclassstorage.blob.core.windows.net/shotclass/devtest1/Priyanka/insu3.jpg",
      Description: "VQ/VT",
      IsClassDownloadable: false,
      IsMediaDownloadable: false,
      IsRandomQuestionAllowed: false,
      IsRestrictedClass: false,
      IsVideoMandatory: false,
      KeyLearning: "VQ/VT",
      LearnerChangeAnswerOptions: false,
      Locale: shotclassData.details.Language,
      Logo: "https://mlearn.blob.core.windows.net/shotclass/img/hp-logo.gif",
      MediaSource: "",
      Mediatype: 0,
      MoocCourseSubType: 0,
      ParentId: 0,
      ShotClassType: "QuizOnly",
      ShotclassTargetGroupMapping: [],
      ShowCorrectAnswer: true,
      Status: Status ? Status : "Published",
      Survey: {
        IsMandatory: true,
        Locale: shotclassData.details.Language,
        Questions: [],
        ShotClassId: 20,
        SurveyId: "",
      },
      Tags: shotclassData.details.Tags,
      // TrainingTypeId: [parseInt(shotclassData.details.TrainingType)],
      TrainingTypeId: shotclassData.details.TrainingType?.map(
        (training) => training.TypeId
      ),
      Type: "ShotClass",
      VideoThumbnailUrl:
        "https://dev1shotclassstorage.blob.core.windows.net/shotclass/devtest1/Priyanka/insu3.jpg",
      VideoUploadStatus: "VideoNotAvailable",
      VideoUrl: "",
    };
    await apis.manage
      .createShotclass(data)
      .then((response) => {
        if (response?.data) {
          console.log(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const updateEventShotclassActionHandler =
  (shotclassData, status) => async (dispatch) => {
    let quizQuestionList = shotclassData?.addQuiz?.QuestionsList?.map(
      (question, index) => {
        let {
          Question,
          QuestionImage,
          Explanation,
          ActiveQuestionType,
          IsCorrect,
          AnswersList,
          Duration,
          ...restQuestion
        } = question;
        return {
          ...restQuestion,
          Type: ActiveQuestionType,
          Text: Question,
          QuestionNo: index + 1,
          ChoiceList:
            ActiveQuestionType === 1
              ? AnswersList?.map((answer, index) => {
                let { Answer, AnswerImage, ...restAnswer } = answer;
                return {
                  ...restAnswer,
                  Text: Answer,
                  IsAnswer: parseInt(IsCorrect) === index,
                  IsDeleted: answer?.IsDeleted || false,
                  ChoiceImageList: AnswerImage?.MediaUri
                    ? {
                      MediaUri: AnswerImage?.MediaUri,
                      FileName: AnswerImage?.FileName,
                      Mediaid: AnswerImage?.Mediaid,
                      FileType: AnswerImage?.FileType,
                      FileSizeinKB: AnswerImage?.FileSizeinKB,
                      Base64: "",
                      ThumbnailUri: AnswerImage?.ThumbnailUri,
                      LabelValue: "",
                    }
                    : null,
                  // ChoiceAudioList: null,
                  // ChoiceVideoList: null,
                };
              })
              : question?.ChoiceList?.length > 1
                ? AnswersList.map((answer) => {
                  let { Answer, AnswerImage, ...restAnswer } = answer;
                  if (answer?.Text === "True") {
                    return {
                      ...restAnswer,
                      Text: "True",
                      IsAnswer: IsCorrect === "True",
                      keyText: "TRUE_TEXT",
                    };
                  } else {
                    return {
                      ...restAnswer,
                      Text: "False",
                      IsAnswer: IsCorrect === "False",
                      keyText: "FALSE_TEXT",
                    };
                  }
                })
                : [
                  {
                    Text: "True",
                    IsAnswer: IsCorrect === "True",
                    keyText: "TRUE_TEXT",
                  },
                  {
                    Text: "False",
                    IsAnswer: IsCorrect === "False",
                    keyText: "FALSE_TEXT",
                  },
                ],
          Explaination: Explanation,
          Duration: Duration,
          // QuestionImageList:
          //   question?.QuestionImage?.[0]?.checked == true
          //     ? question?.QuestionImage?.map((item) => {
          //       return {
          //         MediaUri: item?.MediaUri,
          //         FileName: item?.FileName,
          //         Mediaid: item?.Mediaid,
          //         FileType: item?.FileType,
          //         FileSizeinKB: item?.FileSizeinKB,
          //         Base64: "",
          //         ThumbnailUri: item?.ThumbnailUri,
          //         LabelValue: "",
          //         isSelected: true,
          //       };
          //     })
          //     : [],
          QuestionImageList: QuestionImage?.length > 0 ? QuestionImage.map((itme) => {
            return {
              MediaUri: itme?.MediaUri,
              FileName: itme?.FileName,
              Mediaid: itme?.Mediaid,
              FileType: itme?.FileType,
              FileSizeinKB: itme?.FileSizeinKB,
              Base64: "",
              ThumbnailUri: itme?.ThumbnailUri,
              LabelValue: "",
              isSelected: true,
            }
          }) : [],

          // QuestionImageList: QuestionImage?.MediaUri
          //   ? [
          //       {
          //         MediaUri: QuestionImage?.MediaUri,
          //         FileName: QuestionImage?.FileName,
          //         Mediaid: QuestionImage?.Mediaid,
          //         FileType: QuestionImage?.FileType,
          //         FileSizeinKB: QuestionImage?.FileSizeinKB,
          //         Base64: "",
          //         ThumbnailUri: QuestionImage?.ThumbnailUri,
          //         LabelValue: "",
          //         isSelected: true,
          //       },
          //     ]
          //   : [],
        };
      }
    );
    let data = {
      ...shotclassData.Other,
      ParentId: shotclassData.shotclassId.toString(),
      AssessmentSet: {
        // ...shotclassData.Other.AssessmentSet,
        ...shotclassData?.Other?.AssessmentSet,
        QuestionList:
        shotclassData?.addQuiz?.TotalQuestionCount > 0
        ? quizQuestionList
        : [],
        ParentId: shotclassData?.Other.AssessmentSet.ID,
      },
      EnableTimer: shotclassData.addQuiz.EnableTimer || false,
      QuizDuration: shotclassData.addQuiz.QuizDuration || 0,
      Tags: shotclassData.details.Tags,
      Status: status ? status : "Published",
      // TrainingTypeId: [parseInt(shotclassData.details.TrainingType)],
      TrainingTypeId: shotclassData.details.TrainingType?.map(
        (training) => training.TypeId
      ),
    };
    // debugger;
    await apis.manage
      .updateShotclass(data)
      .then((response) => {
        if (response?.data) {
          console.log(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const copyEventShotclassActionHandler =
  (shotclassData, status) => async (dispatch) => {
    let quizQuestionList = shotclassData?.addQuiz?.QuestionsList?.map(
      (question, index) => {
        let {
          Question,
          QuestionImage,
          Explanation,
          ActiveQuestionType,
          IsCorrect,
          AnswersList,
          Duration,
          ...restQuestion
        } = question;
        return {
          ...restQuestion,
          Type: ActiveQuestionType,
          Text: Question,
          QuestionNo: index + 1,
          ChoiceList:
            ActiveQuestionType === 1
              ? AnswersList?.map((answer, index) => {
                let { Answer, AnswerImage, ...restAnswer } = answer;
                return {
                  ...restAnswer,
                  Text: Answer,
                  IsAnswer: parseInt(IsCorrect) === index,
                  ChoiceImageList: AnswerImage?.MediaUri
                    ? {
                      MediaUri: AnswerImage?.MediaUri,
                      FileName: AnswerImage?.FileName,
                      Mediaid: AnswerImage?.Mediaid,
                      FileType: AnswerImage?.FileType,
                      FileSizeinKB: AnswerImage?.FileSizeinKB,
                      Base64: "",
                      ThumbnailUri: AnswerImage?.ThumbnailUri,
                      LabelValue: "",
                    }
                    : null,
                };
              })
              : question?.ChoiceList?.length > 1
                ? AnswersList.map((answer) => {
                  let { Answer, AnswerImage, ...restAnswer } = answer;
                  if (answer?.Text === "True") {
                    return {
                      ...restAnswer,
                      Text: "True",
                      IsAnswer: IsCorrect === "True",
                      keyText: "TRUE_TEXT",
                    };
                  } else {
                    return {
                      ...restAnswer,
                      Text: "False",
                      IsAnswer: IsCorrect === "False",
                      keyText: "FALSE_TEXT",
                    };
                  }
                })
                : [
                  {
                    Text: "True",
                    IsAnswer: IsCorrect === "True",
                    keyText: "TRUE_TEXT",
                  },
                  {
                    Text: "False",
                    IsAnswer: IsCorrect === "False",
                    keyText: "FALSE_TEXT",
                  },
                ],
          Explaination: Explanation,
          Duration: Duration,
          QuestionImageList:
            // question?.QuestionImage?.[0]?.checked == true
            question?.QuestionImage.length > 0
              ? question?.QuestionImage?.map((item) => {
                return {
                  MediaUri: item?.MediaUri,
                  FileName: item?.FileName,
                  Mediaid: item?.Mediaid,
                  FileType: item?.FileType,
                  FileSizeinKB: item?.FileSizeinKB,
                  Base64: "",
                  ThumbnailUri: item?.ThumbnailUri,
                  LabelValue: "",
                  isSelected: true,
                };
              })
              : [],
          // QuestionImageList: QuestionImage?.MediaUri
          //   ? [
          //       {
          //         MediaUri: QuestionImage?.MediaUri,
          //         FileName: QuestionImage?.FileName,
          //         Mediaid: QuestionImage?.Mediaid,
          //         FileType: QuestionImage?.FileType,
          //         FileSizeinKB: QuestionImage?.FileSizeinKB,
          //         Base64: "",
          //         ThumbnailUri: QuestionImage?.ThumbnailUri,
          //         LabelValue: "",
          //         isSelected: true,
          //       },
          //     ]
          //   : [],
        };
      }
    );
    let data = {
      ...shotclassData.Other,
      Name: shotclassData?.details?.Name,
      // ParentId: shotclassData.shotclassId.toString(),
      AssessmentSet: {
        ...shotclassData?.Other.AssessmentSet,
        Name: shotclassData?.details?.Name,
        QuestionList:
        shotclassData?.addQuiz?.TotalQuestionCount > 0
        ? quizQuestionList
        : [],
        // ParentId: shotclassData?.Other.AssessmentSet.ID,
      },
      EnableTimer: shotclassData.addQuiz.EnableTimer || false,
      QuizDuration: shotclassData.addQuiz.QuizDuration || 0,
      Tags: shotclassData.details.Tags,
      Status: status ? status : "Published",
      // TrainingTypeId: [parseInt(shotclassData.details.TrainingType)],
      TrainingTypeId: shotclassData.details.TrainingType?.map(
        (training) => training.TypeId
      ),
    };
    await apis.manage
      .copyShotclass(data)
      .then((response) => {
        if (response?.data) {
          console.log(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const getUserByNameActionHandler =
  (searchText, setState) => async () => {
    return await apis.events
      .getUserByName(searchText)
      .then((response) => {
        if (response.data) {
          const updatedData = response.data.map((item) => {
            return {
              ...item,
              fullName: item.FirstName + " " + item.LastName,
              fullNameLoginId: item.FirstName + "(" + item.LoginId + ")",
            };
          });
          // console.log(",,,,,,,,,,,,,,,,,,,,", updatedData);
          setState(updatedData);
          return response;
        } else {
          setState(null);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const postCreatePasscodeActionHandler = (data, setLoader) => async (dispatch) => {
  setLoader(true)
  await apis.events
    .postLiveQuizEvent(data)
    .then((response) => {
      if (response.status === 200) {
        dispatch(setErrorHandler(SUCCESS, "Quiz Event Created"));
      } else {
        console.log("data not uploaded");
      }
    })
    .catch((err) => {
      if (
        err.response.data ===
        "Request Passcode already exist, please provide new passscode."
      ) {
        dispatch(setErrorHandler(FAIL, err.response.data));
      } else {
        dispatch(
          setErrorHandler(
            FAIL,
            "Quiz was not created, please enter correct details"
          )
        );
      }
      console.log(err);
    }).finally(() => {
      setLoader(false)
    })
};

export const eventGetClassByTagsLiveTrainingActionHandler =
  (setState) => async () => {
    await apis.events
      .getClassByTagsLiveTraining()
      .then((response) => {
        if (response.data) {
          const eventData = response.data.Content?.map((item) => {
            return { ...item, EventName: item.Name };
          });
          // console.log("live", eventData)
          setState(eventData);
        } else {
          setState(null);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

export const eventGetClassByTagsVirtualTrainingActionHandler =
  (setState) => async () => {
    await apis.events
      .getClassByTagsVirtualTraining()
      .then((response) => {
        if (response.data) {
          const eventData = response.data.Content?.map((item) => {
            return { ...item, EventName: item.Name };
          });
          // console.log("virtual", eventData)
          setState(eventData);
        } else {
          setState(null);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
